<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">公告分类</span>
      </div>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="handleAdd('新增分类')">新增
      </el-button>
      <el-table :data="tableData"
                border default-expand-all stripe
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%;margin-bottom: 20px;"
                :cell-style="{'text-align':'center'}"
                @selection-change="handleSelectionChange">
        <el-table-column label="全选" width="50" type="selection"/>
        <el-table-column prop="noticeTypeNumbers" label="平台">
          <template slot-scope="scope">
            <span>{{getNoticeType(scope.row.noticeTypeNumbers)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="noticeTypeName" label="分类名称"/>
        <el-table-column prop="remarks" label="备注"/>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" plain
                       @click="handleEdit(scope.$index, scope.row,'修改分类')">
              编辑
            </el-button>
            <el-button size="mini" type="success" plain
                       @click="handleDelete(scope.$index, scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
        <el-form-item label="平台" prop="status">
          <el-select v-model="dialogForm.noticeTypeNumbers" clearable placeholder="请选择平台">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称">
          <el-input v-model="dialogForm.noticeTypeName" style="width: 50%;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm" size="mini" type="primary">提交</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {addNoticeType, deleteNoticeType, getAllNoticeType, updateNoticeType} from "../../api/b2cbusiness/b2c_admin";

export default {
  name: "NotificationTypeManagelist",
  mixins: [MixinCUD],
  data() {
    return {
      tableData: [],
      queryForm: {},
      options: [{
        label: "业务员",
        value: 376511744689196,
      }, {
        label: "商家",
        value: 7350203555542976,
      },
        {
          label: "试客",
          value: 5135469494853169,
        },
        {
          label: "主播",
          value: 6866063603665680,
        },
      ],
      dialogFormVisible: false,
      dialogTitle: "添加备注",
      dialogRefName: "dialogForm",
      dialogForm: {
        systemPlateform: "",
        remarks: "",
      },
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  mounted() {
    this.getData();
  },
  computed:{
    getNoticeType(){
      return function (value) {
        for (let item in this.options){
          if (this.options[item].value == value){
            return this.options[item].label;
          }
        }
      }
    }
  },
  methods: {
    handleAdd(dialogTitle) {
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
      this.resetDialogForm()
    },
    updateData(){
      updateNoticeType(this.dialogForm).then(res=>{
        if (res.success){
          this.$message.success("修改分类成功");
          this.getData();
          this.dialogFormVisible=false;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    deleteData(){
      deleteNoticeType(this.dialogForm.id).then(res=>{
        if (res.success){
          this.$message.success("删除分类成功");
          this.getData();
          this.dialogFormVisible=false;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    addData(){
      addNoticeType(this.dialogForm).then(res=>{
        if (res.success){
          this.$message.success("添加分类成功");
          this.getData();
          this.dialogFormVisible=false;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getData() {
      getAllNoticeType(this.pagination).then(res => {
        if (res.success) {
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handlePageSizeChange(val) {
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val) {
      this.pagination.pageNum = val;
      this.submitQueryForm()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.el-tree--highlight-current /deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: rgb(31, 158, 254);
  color: rgb(255, 255, 255);
}
</style>
